import { render, staticRenderFns } from "./EditarprocedimientoV2.vue?vue&type=template&id=72a290cb"
import script from "./EditarprocedimientoV2.vue?vue&type=script&lang=js"
export * from "./EditarprocedimientoV2.vue?vue&type=script&lang=js"
import style0 from "./EditarprocedimientoV2.vue?vue&type=style&index=0&id=72a290cb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports